/**
 * FJX · Largo + color + talla + "Lleva mas, paga menos" · v1.3 (21-oct-2026)
 * Tema Pruebas 003 - PERF-FIX 21 - OCTUBRE - FTX. Lo imprime snippets/fjx-largo.liquid
 * (solo REF. 024640, 024500 y 024550).
 * v1.2: "prendas" -> "shorts"; el texto de uso solo se muestra en la prenda 1.
 * v1.3: cada prenda adicional se titula "Short Push Up 2" / "Short Push Up 3" y debajo
 *       muestra largo · color · talla.
 * - Prenda 1 = la de la ficha. Cambiar su largo lleva al producto de ese largo.
 *   Cambiar su color o talla mueve el selector oculto del tema (galeria y precio del tema).
 * - Prendas 2 y 3: largo, color y talla propios (sin salir de la pagina).
 * - El descuento real lo aplica Shopify; aqui solo se calcula. Evento GA4: fjx_largo_add.
 */
(function () {
  if (customElements.get('fjx-largo')) return;

  var SLOT_NAME = 'Short Push Up';
  var BODY = 'M10 5 H34 C36.5 11 38 16 37.5 22 L34 56 H25 L22 21 L19 56 H10 L6.5 22 C6 16 7.5 11 10 5 Z';
  var FALL = { beige: '#e8cdb5', negro: '#1d1a1f', cocoa: '#8a5a44', chocolate: '#5b3a2e', blanco: '#ffffff', indigo: '#2f3b6b', marfil: '#f3ead8' };
  var ICON = {
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>',
    up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>'
  };
  var uid = 0;

  function money(c) { var v = Math.round(c / 100); return '$' + v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function nice(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }

  customElements.define('fjx-largo', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var D;
      try { D = JSON.parse(this.querySelector('[data-lg-data]').textContent); } catch (e) { return; }
      if (!D || !D.l || !D.l.length) return;
      this.L = D.l; this.p2 = D.p2 || 0; this.p3 = D.p3 || 0; this.free = D.free || 0;
      var cur = D.cur || 0;
      var v0 = this.byId(cur, D.v) || this.firstA(cur);
      this.S = [{ l: cur, v: v0 }];
      this.n = 1; this.open = -1;
      this.$main = this.querySelector('[data-lg-main]');
      this.$steps = this.querySelector('[data-lg-steps]');
      this.$nudge = this.querySelector('[data-lg-nudge]');
      this.$slots = this.querySelector('[data-lg-slots]');
      this.$old = this.querySelector('[data-lg-old]');
      this.$tot = this.querySelector('[data-lg-tot]');
      this.$chips = this.querySelector('[data-lg-chips]');
      this.$add = this.querySelector('[data-act="add"]');
      this.$msg = this.querySelector('[data-lg-msg]');
      var sec = this.closest('.product-information--inner') || document;
      this.guide = sec.querySelector('[id^="ProductPopup-"]') || document.querySelector('[id^="ProductPopup-"]');
      this.addEventListener('click', this.onClick.bind(this));
      this.render();
    }

    /* ---------- datos ---------- */
    d(l) { return this.L[l].d; }
    byId(l, id) { var vs = this.d(l).v; for (var i = 0; i < vs.length; i++) if (vs[i].id === id && vs[i].a) return vs[i]; return null; }
    firstA(l) { var vs = this.d(l).v; for (var i = 0; i < vs.length; i++) if (vs[i].a) return vs[i]; return vs[0]; }
    values(l, idx) { if (idx < 0) return []; var out = []; this.d(l).v.forEach(function (v) { if (out.indexOf(v.o[idx]) === -1) out.push(v.o[idx]); }); return out; }
    find(l, size, color) {
      var it = this.d(l), best = null;
      it.v.forEach(function (v) {
        if (best || !v.a) return;
        if (it.si >= 0 && size != null && v.o[it.si] !== size) return;
        if (it.ci >= 0 && color != null && v.o[it.ci] !== color) return;
        best = v;
      });
      return best;
    }
    sizeOf(l, v) { var si = this.d(l).si; return si >= 0 ? v.o[si] : null; }
    colorOf(l, v) { var ci = this.d(l).ci; return ci >= 0 ? v.o[ci] : null; }
    keep(toL, fromL, v) {
      var s = this.sizeOf(fromL, v), c = this.colorOf(fromL, v);
      return this.find(toL, s, c) || this.find(toL, null, c) || this.find(toL, s, null) || this.firstA(toL);
    }
    colorOk(l, c) { return !!this.find(l, null, c); }
    swatch(l, c) {
      var sw = this.L[l].sw || {};
      return sw[c] || FALL[String(c).toLowerCase().trim()] || '#d8d3dd';
    }
    pct(k) { return k >= 3 ? this.p3 : (k === 2 ? this.p2 : 0); }
    price(i) { var s = this.S[i] || this.S[0]; return s.v.p; }
    sumK(k) { var f = 0; for (var i = 0; i < k; i++) f += this.price(i); return f; }
    setN(k) {
      while (this.S.length < k) this.S.push({ l: this.S[0].l, v: this.S[0].v });
      if (this.S.length > k) this.S = this.S.slice(0, k);
      this.n = k;
    }

    /* ---------- dibujo ---------- */
    sil(y, on) {
      var id = 'fjxlg' + (uid++), f = on ? '#6B2A8A' : '#c9c3ce';
      return '<svg viewBox="0 0 44 60" aria-hidden="true"><defs><clipPath id="' + id + '"><rect x="0" y="5" width="44" height="' + (y - 5) + '"/></clipPath></defs>' +
        '<path d="' + BODY + '" fill="none" stroke="#a39ba9" stroke-width="0.8" stroke-linejoin="round"/>' +
        '<path d="' + BODY + '" fill="' + f + '" clip-path="url(#' + id + ')"/>' +
        '<line x1="4" y1="' + y + '" x2="40" y2="' + y + '" stroke="' + f + '" stroke-width="0.8" stroke-dasharray="1.5 1.5"/></svg>';
    }

    picker(i) {
      var self = this, it = this.S[i], l = it.l, P = this.L[l], d = this.d(l), h = '';
      h += '<div class="fjx-lg__sec"><p class="fjx-lg__hl"><span>Largo: <b>' + esc(P.n) + '</b></span></p><div class="fjx-lg__lg" role="radiogroup" aria-label="Largo">';
      this.L.forEach(function (q, j) {
        var on = j === l;
        h += '<button type="button" class="fjx-lg__lt' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-act="largo" data-i="' + i + '" data-v="' + j + '">' + self.sil(q.y, on) + '<span>' + esc(q.n) + '</span></button>';
      });
      h += '</div>' + (P.u && i === 0 ? '<p class="fjx-lg__use">' + esc(P.u) + '</p>' : '') + '</div>';

      var colors = this.values(l, d.ci);
      if (colors.length) {
        var cc = this.colorOf(l, it.v);
        h += '<div class="fjx-lg__sec"><p class="fjx-lg__hl"><span>Color: <b>' + esc(nice(cc)) + '</b></span></p><div class="fjx-lg__cr" role="radiogroup" aria-label="Color">';
        colors.forEach(function (c) {
          var on = c === cc, ok = self.colorOk(l, c);
          h += '<button type="button" class="fjx-lg__sw' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + esc(nice(c)) + (ok ? '' : ', agotado') + '" style="background:' + esc(self.swatch(l, c)) + '" data-act="color" data-i="' + i + '" data-v="' + esc(c) + '"' + (ok ? '' : ' disabled') + '></button>';
        });
        h += '</div></div>';
      }

      var sizes = this.values(l, d.si);
      if (sizes.length) {
        var zz = this.sizeOf(l, it.v), col = this.colorOf(l, it.v);
        h += '<div class="fjx-lg__sec"><p class="fjx-lg__hl"><span>Talla: <b>' + esc(zz) + '</b></span>' + (i === 0 && this.guide ? '<button type="button" class="fjx-lg__link" data-act="guide">Guía de tallas</button>' : '') + '</p><div class="fjx-lg__zr" role="radiogroup" aria-label="Talla">';
        sizes.forEach(function (z) {
          var on = z === zz, ok = !!self.find(l, z, col);
          h += '<button type="button" class="fjx-lg__sz' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" aria-label="Talla ' + esc(z) + (ok ? '' : ', agotada') + '" data-act="size" data-i="' + i + '" data-v="' + esc(z) + '"' + (ok ? '' : ' disabled') + '>' + esc(z) + '</button>';
        });
        h += '</div></div>';
      }
      return h;
    }

    render(focus) {
      var self = this; uid = 0;
      this.$main.innerHTML = this.picker(0);

      var h = '';
      [1, 2, 3].forEach(function (k) {
        var f = self.sumK(k), pc = self.pct(k), now = f * (1 - pc / 100), on = k === self.n;
        h += '<button type="button" class="fjx-lg__sp' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-act="step" data-v="' + k + '">' +
          (k === 2 ? '<span class="fjx-lg__bd">Recomendado</span>' : (k === 3 ? '<span class="fjx-lg__bd is-alt">Mejor precio</span>' : '')) +
          '<span class="fjx-lg__q">' + (k === 1 ? '1 short' : k + ' shorts') + '</span>' +
          '<span class="fjx-lg__off' + (pc ? '' : ' is-no') + '">' + (pc ? pc + '% OFF' : 'Normal') + '</span>' +
          '<span class="fjx-lg__u">' + money(now / k) + '</span><s>' + (pc ? money(f / k) : '') + '</s>c/u</button>';
      });
      this.$steps.innerHTML = h;

      var g = '';
      if (this.n === 1 && this.p2) {
        g = ICON.tag + '<span>Agrega 1 short más: <b>' + this.p2 + '% OFF y ahorras ' + money(this.sumK(2) * this.p2 / 100) + '</b></span>';
      } else if (this.n === 2 && this.p3) {
        var extra = this.sumK(3) * this.p3 / 100 - this.sumK(2) * this.p2 / 100;
        g = ICON.up + '<span>Con 1 más pasas al <b>' + this.p3 + '% OFF y ahorras ' + money(extra) + ' adicionales</b></span>';
      } else if (this.n >= 3) {
        g = ICON.ok + '<span>Tienes el <b>' + this.p3 + '% OFF</b>, el mejor precio de la promo</span>';
      }
      this.$nudge.innerHTML = g ? '<p class="fjx-lg__nudge">' + g + '</p>' : '';

      var s = '';
      for (var i = 1; i < this.n; i++) {
        var it = this.S[i], q = this.L[it.l], c = this.colorOf(it.l, it.v), z = this.sizeOf(it.l, it.v), nm = SLOT_NAME + ' ' + (i + 1);
        var meta = [q.n, c ? nice(c) : '', z ? 'Talla ' + z : ''].filter(Boolean).join(' · ');
        s += '<div class="fjx-lg__sl"><div class="fjx-lg__sh"><div><p class="fjx-lg__sn">' + esc(nm) + '</p><p class="fjx-lg__sm">' + esc(meta) + '</p></div>' +
          (this.open === i ? '<button type="button" class="fjx-lg__ed" data-act="done">Listo</button>' : '<button type="button" class="fjx-lg__ed" data-act="edit" data-i="' + i + '" aria-label="Cambiar ' + esc(nm) + '">Cambiar</button>') +
          '</div>' + (this.open === i ? this.picker(i) : '') + '</div>';
      }
      this.$slots.innerHTML = s;

      var full = this.sumK(this.n), pc2 = this.pct(this.n), now2 = Math.round(full * (1 - pc2 / 100));
      this.total = now2;
      this.$old.textContent = pc2 ? money(full) : '';
      this.$tot.textContent = money(now2);
      var ch = '';
      if (pc2) ch += '<span class="fjx-lg__chip">' + ICON.tag + pc2 + '% OFF · Ahorras ' + money(full - now2) + '</span>';
      if (this.free && now2 >= this.free) ch += '<span class="fjx-lg__chip">' + ICON.truck + 'Envío gratis</span>';
      this.$chips.innerHTML = ch;
      this.$add.textContent = (this.n === 1 ? 'Agregar al carrito' : 'Agregar ' + this.n + ' shorts') + ' · ' + money(now2);

      if (focus) {
        var sel = '[data-act="' + focus.act + '"]' + (focus.i != null ? '[data-i="' + focus.i + '"]' : '') + (focus.v != null ? '[data-v="' + String(focus.v).replace(/"/g, '\\"') + '"]' : '');
        var f = this.querySelector(sel);
        if (f) f.focus();
      }
    }

    /* ---------- acciones ---------- */
    onClick(e) {
      var b = e.target.closest('[data-act]');
      if (!b || !this.contains(b) || b.disabled) return;
      var a = b.dataset.act, i = b.dataset.i != null ? parseInt(b.dataset.i, 10) : null, v = b.dataset.v;
      var it = i != null ? this.S[i] : null;
      if (a === 'add') { this.submit(); return; }
      if (a === 'guide') { if (this.guide) this.guide.click(); return; }
      if (a === 'largo') {
        var nl = parseInt(v, 10);
        if (nl === it.l) return;
        var nv = this.keep(nl, it.l, it.v);
        if (i === 0) {
          b.setAttribute('aria-busy', 'true');
          window.location.href = this.L[nl].url + (nv ? '?variant=' + nv.id : '');
          return;
        }
        it.l = nl; it.v = nv;
      } else if (a === 'color') {
        it.v = this.find(it.l, this.sizeOf(it.l, it.v), v) || this.find(it.l, null, v) || it.v;
        if (i === 0) this.syncTheme(it.v);
      } else if (a === 'size') {
        it.v = this.find(it.l, v, this.colorOf(it.l, it.v)) || it.v;
        if (i === 0) this.syncTheme(it.v);
      } else if (a === 'step') {
        var k = parseInt(v, 10), prev = this.n;
        this.setN(k);
        this.open = k > prev ? k - 1 : -1;
      } else if (a === 'edit') {
        this.open = i;
      } else if (a === 'done') {
        this.open = -1;
      }
      this.render({ act: a, i: i, v: v });
    }

    /* Mueve el selector oculto del tema para que galeria, precio y URL sigan la eleccion */
    syncTheme(v) {
      var vs = document.querySelector('variant-selects[data-fjx-hidden]');
      if (!vs || !v) return;
      var fs = vs.querySelectorAll('fieldset.product-form__input'), last = null;
      v.o.forEach(function (val, k) {
        var f = fs[k]; if (!f) return;
        var sel = f.querySelector('select');
        if (sel) { if (sel.value !== val) { sel.value = val; last = sel; } return; }
        var inputs = f.querySelectorAll('input[type="radio"]');
        for (var j = 0; j < inputs.length; j++) {
          if (inputs[j].value === val) { if (!inputs[j].checked) { inputs[j].checked = true; last = inputs[j]; } break; }
        }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }

    submit() {
      var self = this;
      if (this.$add.getAttribute('aria-busy') === 'true') return;
      this.$msg.hidden = true;
      var map = {}, picked = this.S.slice(0, this.n);
      picked.forEach(function (s) { map[s.v.id] = (map[s.v.id] || 0) + 1; });
      var items = Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
      this.$add.setAttribute('aria-busy', 'true');
      var label = this.$add.textContent; this.$add.textContent = 'Agregando…';
      var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
      fetch(addUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        self.$add.removeAttribute('aria-busy'); self.$add.textContent = label;
        if (res.status) { self.$msg.textContent = res.description || 'No pudimos agregar los shorts. Revisa las tallas e intenta de nuevo.'; self.$msg.hidden = false; return; }
        var parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && res.sections && res.sections['cart-drawer']) {
          var inner = parse(res.sections['cart-drawer']).querySelector('.cart-drawer'); if (inner) drawer.innerHTML = inner.innerHTML;
        }
        var toggle = document.getElementById('cart-drawer-toggle');
        if (toggle && res.sections && res.sections['cart-bubble']) {
          var cur = toggle.querySelector('.thb-item-count'), nx = parse(res.sections['cart-bubble']).querySelector('.thb-item-count');
          if (cur && nx) cur.innerHTML = nx.innerHTML;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'fjx_largo_add', fjx_units: self.n, fjx_largos: picked.map(function (s) { return self.L[s.l].n; }).join('|'), value: Math.round(self.total) / 100, currency: 'COP', items: items.map(function (x) { return { item_id: String(x.id), quantity: x.quantity }; }) });
        if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart:item-added', { product: res.items ? res.items[0] : res });
        if (toggle) toggle.click();
      }).catch(function () {
        self.$add.removeAttribute('aria-busy'); self.$add.textContent = label;
        self.$msg.textContent = 'No pudimos agregar los shorts. Revisa tu conexión e intenta de nuevo.'; self.$msg.hidden = false;
      });
    }
  });
})();
